export default __webpack_public_path__ + "static/media/zari_2.64e6b11e.jpeg";